import Path from "enums/Path";

const links = [
  { title: "Your Releases", path: Path.Home },
  { title: "Wallet", path: Path.Wallet },
  { title: "Account", path: Path.Account },
];

export default links;
